import React from 'react';
import { Button } from '../ui/button';
import { Input } from '../ui/input';
import { Label } from '../ui/label';
import { Dialog, DialogContent, DialogHeader, DialogTitle } from '../ui/dialog';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '../ui/select';

const VEHICLE_TYPES = [
  { value: 'sedan', label: 'Sedán' },
  { value: 'suv', label: 'SUV' },
  { value: 'pickup', label: 'Pickup' },
  { value: 'motocicleta', label: 'Motocicleta' },
  { value: 'otro', label: 'Otro' },
];

export default function NewVehicleModal({ open, onOpenChange, data, onChange, onSubmit }) {
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent>
        <DialogHeader>
          <DialogTitle>Nuevo Vehículo</DialogTitle>
        </DialogHeader>
        <form onSubmit={onSubmit} className="space-y-4">
          <div>
            <Label>Tipo de Vehículo *</Label>
            <Select
              value={data.type}
              onValueChange={(value) => onChange({ ...data, type: value })}
            >
              <SelectTrigger className="mt-1" data-testid="new-vehicle-type">
                <SelectValue />
              </SelectTrigger>
              <SelectContent>
                {VEHICLE_TYPES.map((type) => (
                  <SelectItem key={type.value} value={type.value}>
                    {type.label}
                  </SelectItem>
                ))}
              </SelectContent>
            </Select>
          </div>
          <div>
            <Label htmlFor="new-vehicle-model">Modelo</Label>
            <Input
              id="new-vehicle-model"
              value={data.model}
              onChange={(e) => onChange({ ...data, model: e.target.value })}
              placeholder="Ej: Honda Civic 2020"
              className="mt-1"
              data-testid="new-vehicle-model"
            />
          </div>
          <div>
            <Label htmlFor="new-vehicle-plates">Placas</Label>
            <Input
              id="new-vehicle-plates"
              value={data.plates}
              onChange={(e) => onChange({ ...data, plates: e.target.value })}
              placeholder="ABC-123"
              className="mt-1"
              data-testid="new-vehicle-plates"
            />
          </div>
          <div>
            <Label htmlFor="new-vehicle-color">Color</Label>
            <Input
              id="new-vehicle-color"
              value={data.color}
              onChange={(e) => onChange({ ...data, color: e.target.value })}
              placeholder="Blanco"
              className="mt-1"
              data-testid="new-vehicle-color"
            />
          </div>
          <Button type="submit" className="w-full" data-testid="save-new-vehicle-btn">
            Guardar Vehículo
          </Button>
        </form>
      </DialogContent>
    </Dialog>
  );
}
